/**
 * Model for a wrestling WeightClass.
 */
import { v4 as UUID } from 'uuid';
import isNil from 'lodash-es/isNil';

export class WeightClass {
    public id: string = null;
    public isNew: boolean = true;
    public name: string = null;
    public minWeight: number = null;
    public maxWeight: number = null;
    public sequence: number = 0;

    constructor(id: string = null) {
        this.id = id || UUID();
    }

    public clone(): WeightClass {
        const clone: WeightClass = new WeightClass();
        clone.id = this.id;
        clone.isNew = this.isNew;
        clone.name = this.name;
        clone.minWeight = this.minWeight;
        clone.maxWeight = this.maxWeight;
        clone.sequence = this.sequence;
        return clone;
    }

    public isEmpty(): boolean {
        return (!this.name && !this.maxWeight && !this.minWeight);
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'weightClass';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.minWeight = isNil(this.minWeight) ? null : parseFloat(this.minWeight.toString());
        json.data.attributes.maxWeight = isNil(this.maxWeight) ? null : parseFloat(this.maxWeight.toString());
        json.data.attributes.sequence = isNil(this.sequence) ? null : parseInt(this.sequence.toString(), null);
        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): WeightClass {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.isNew = false;
        this.name = attrs['name'];
        this.minWeight = attrs['minWeight'] && parseFloat(attrs['minWeight']);
        this.maxWeight = attrs['maxWeight'] && parseFloat(attrs['maxWeight']);
        this.sequence = attrs['sequence'];

        return this;
    }
}
